/**
 * Wire-format types for the announcements API. Mirror CSC_CORE.Features.Announcements DTOs.
 * Values mirror the backend AnnouncementPriorityEnum / AnnouncementStatusEnum (int).
 * Keep them as numeric literals matching the backend so JSON round-trips correctly.
 */

export enum AnnouncementPriority {
  Normal = 0,
  Important = 1,
  Critical = 2,
}

export enum AnnouncementStatus {
  Draft = 0,
  Published = 1,
  Archived = 2,
}

export interface AnnouncementDto {
  id: number;
  title: string;
  content: string;
  priority: AnnouncementPriority;
  status: AnnouncementStatus;
  isPinned: boolean;
  publishAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  createdById: number;
  updatedAt: string | null;
  updatedById: number | null;
}

export interface AnnouncementListItemDto {
  id: number;
  title: string;
  priority: AnnouncementPriority;
  status: AnnouncementStatus;
  isPinned: boolean;
  publishAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  createdById: number;
}

export interface CreateAnnouncementDto {
  title: string;
  content: string;
  priority: AnnouncementPriority;
  status: AnnouncementStatus;
  isPinned: boolean;
  publishAt: string | null;
  expiresAt: string | null;
}

export type UpdateAnnouncementDto = CreateAnnouncementDto;
